/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import DataVaxiomPersonTitleSelect from 'DesignSystem/Data/DataVaxiom/DataVaxiomPerson/DataVaxiomPersonTitleSelect/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/PatientSelect/Content/Content/New/Title",
  onChange
  
}) {
let appointmentOverlayPatientNewPersonTitleValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.title',
})
let appointmentOverlayPatientNewPersonTitleChangeData = fromData.useDataChange({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.title',
})
  return (<React.Fragment
>
<DataVaxiomPersonTitleSelect
  viewPath={`${viewPath}/DataVaxiomPersonTitleSelect`}
 data="appointment_overlay.patient_new.person.title"
 value={appointmentOverlayPatientNewPersonTitleValueData}
 onChange={appointmentOverlayPatientNewPersonTitleChangeData}
 marginTop={0}
/>
{children}
</React.Fragment>)
}